<template>
  <v-checkbox
    v-model="checkboxValue"
    :label="label"
    :indeterminate="indeterminate"
  />
</template>

<script>
export default {
  name: 'CheckBox',
  props: {
    label: {
      type: String,
      required: true,
    },
    value: {
      type: [Boolean, String],
      required: true,
    },
  },
  emits: ['input'],
  computed: {
    checkboxValue: {
      get() {
        return this.value === 'indeterminate' ? false : this.value;
      },
      set(newValue) {
        this.$emit('input', newValue);
      },
    },
    indeterminate() {
      return this.value === 'indeterminate';
    },
  },
};
</script>

<scss lang="scss" scoped>
</scss>
